import {
  clearSearchCondition,
  changeCheckbox,
  handleSearch,
  updateTag,
  searchInit,
  prefectureLinkOnClick,
  setSubPrefectureAccordionButtonEvent
} from "../../lib/search/search";
import {__} from "../../lib/lang/translator";

document.addEventListener('DOMContentLoaded', function () {

  const checkboxes = document.querySelectorAll('[data-search-container] input[type="checkbox"]');
  const resetButton = document.querySelectorAll('.clearForm');
  const stationModalButtons = document.querySelectorAll('.station_modal_btn')
  const searchButtons = document.querySelectorAll('.search-button');

  // 検索条件を格納（オブジェクトとして初期化）
  let searchCondition = {
    prefecture: [prefecture],
  };

  searchInit(searchCondition);

  // チェックボックスにイベントを付与
  checkboxes.forEach(function (checkbox) {
    checkbox.addEventListener('change', function () {
      changeCheckbox(searchCondition, checkbox);
    });
  });

  //検索ボタンを押した時の処理
  searchButtons.forEach(searchButton => {
    searchButton.addEventListener('click', function () {
      handleSearch(searchCondition);
    });
  })

  // リセットボタン
  resetButton.forEach(function (button) {
    button.addEventListener('click', function () {
      clearSearchCondition(searchCondition, checkboxes);
    });
  });

  //駅一覧モーダルが開いている時の処理
  stationModalButtons.forEach(button => {
    button.addEventListener('click', event => {
      const stationList = document.querySelector('.station_list');
      const modalLineName = document.querySelector('.modal_line_name');
      const modalOfficeCount = document.querySelector('.modal_office_count');
      const modalOfficeCountCase = document.querySelector('[data-remodal-id=modal_2] [data-modal-office-count-case]');
      //モーダルの中身を初期化
      stationList.innerHTML = '';
      modalLineName.innerHTML = '';
      modalOfficeCount.innerHTML = 'Loading';
      modalOfficeCount.classList.add('loading');

      //クリックした市区の情報を取得
      const lineCode = event.currentTarget.getAttribute('data-lineCode');
      const lineName = event.currentTarget.getAttribute('data-lineName');
      const count = event.currentTarget.getAttribute('data-count');

      //その路線の駅情報を取得
      axios.get(route('web.search.stationInfo', {lineCode: lineCode}))
        .then(response => {
          response.data.stationData.forEach((item, index) => {
            //取得した駅情報を元に要素を作成
            const div = document.createElement('div');
            div.className = 'check chin modal_check_area';

            const input = document.createElement('input');
            input.type = 'checkbox';
            input.id = `station${index}`;
            input.name = 'line_station_code';
            input.value = `${lineCode}-${item["station_code"]}_${lineName}-${item["stationName"]}`;

            const label = document.createElement('label');
            label.setAttribute('for', `station${index}`);

            // @TODO 件数を表示する場合はコメントアウトを外す
            // label.innerHTML = `${item["stationName"]}${__('(')}<span>${item["count"]}</span>${__('cases', item["count"])}${__(')')}`;
            label.innerHTML = `${item["stationName"]}`;

            //既に選択されている駅の場合
            if (searchCondition["line_station_code"] && searchCondition["line_station_code"].includes(`${lineCode}-${item["station_code"]}_${lineName}-${item["stationName"]}`)) {
              input.checked = true;
            }

            //要素を追加
            div.appendChild(input);
            div.appendChild(label);
            stationList.appendChild(div);
            modalLineName.innerHTML = lineName;
            modalOfficeCount.classList.remove('loading');
            modalOfficeCount.innerHTML = count;
            modalOfficeCountCase.innerHTML = __('cases_found', count)
          });

          //モーダル内のチェックボックスにイベントを付与
          const stationCheckBoxes = document.querySelectorAll('[data-remodal-id=modal_2] input[type="checkbox"]')
          stationCheckBoxes.forEach(checkbox => {
            checkbox.addEventListener('change', async function () {
              await changeCheckbox(searchCondition, checkbox);

              // 駅選択がなくなった場合は沿線の登録件数を表示
              if (!searchCondition["line_station_code"]) {
                modalOfficeCount.innerHTML = count;
                modalOfficeCountCase.innerHTML = __('cases_found', count);
              }
            });

          });

          //モーダル内のリセットボタンを押した時の処理
          const modalResetButton = document.querySelector('[data-remodal-id=modal_2] .station_clearForm');
          modalResetButton.addEventListener('click', async function () {
            const modalCheckBoxes = document.querySelectorAll('[data-remodal-id=modal_2] input[type="checkbox"]');
            modalCheckBoxes.forEach(checkbox => {
              checkbox.checked = false;
              checkbox.dispatchEvent(new Event('change'));
            });
          });

          //モーダル内の検索ボタンを押した時の処理
          const modalSearchButton = document.querySelector('[data-remodal-id=modal_2] .search-button');

          modalSearchButton.addEventListener('click', function () {
            handleSearch(searchCondition);
          });

        })
        .catch(error => {
          console.error('Error:', error.response.data);
        });
    });
  });

  // 異なる都道府県検索へページ遷移後も共通の条件を維持する
  prefectureLinkOnClick();

  // 全ての都道府県を見るボタンクリックごとに主要都道府県以外の表示・非表示を切り替えるイベントを登録
  setSubPrefectureAccordionButtonEvent();
});
